// components
import { Card, CardsGrid } from '@/components/Card';
import {
  PageSection,
  PageSectionInner,
  PageSectionTitle,
} from '@/components/PageSection';

export function HowItWorks({ content }) {
  return (
    <PageSection>
      <PageSectionInner>
        <PageSectionTitle>{content.title}</PageSectionTitle>
        <CardsGrid>
          {content.items.map((item) => (
            <Card key={`how-it-works-${item.title}`} content={item} />
          ))}
        </CardsGrid>
      </PageSectionInner>
    </PageSection>
  );
}
